import classNames from "classnames";
import React from "react";

export type CaTableBodyProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLTableSectionElement>,
  HTMLTableSectionElement
>;

function CaTableBody({ className, ...props }: CaTableBodyProps) {
  return <tbody className={classNames("[&_tr:last-child]:border-0", className)} {...props} />;
}

export default CaTableBody;
